import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'

import PurchaseTitleDialog from '@components/music/title-details/purchase-title-dialog/PurchaseTitleDialog'
import Button from '@components/shared/Button'
import { TitleContext } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'
import Tippy from '@tippyjs/react'

const PurchaseToPrintButton: React.FC = () => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  return (
    <>
      <Tippy arrow content={<TippyContent />} placement="bottom" maxWidth={210}>
        <Button
          variant="primary"
          onClick={(): void => {
            openDialog('purchase_title_dialog')
          }}
          className="py-1.5 px-3 flex flex-row items-center justify-center text-md">
          {t('action.purchaseToPrint')}
        </Button>
      </Tippy>
      <PurchaseTitleDialog />
    </>
  )
}

const TippyContent: React.FC = () => {
  const { t } = useTranslation()
  const { title } = useContext(TitleContext)

  return (
    <div>
      <p>{title.formattedUnitPrice()}</p>
      {t('hint.purchaseScore.purchase')}
    </div>
  )
}

export default PurchaseToPrintButton
